import type { BriefState, Surface } from "./types";

// Generic default campaign surfaces for fresh brands (PRD-0072).
// Legacy portfolio-specific surface literals remain supported through
// compatibility mappings elsewhere, but they are no longer the default model.
export const SUPPORTED_CAMPAIGN_SURFACES: readonly Surface[] = [
  "linkedin",
  "blog",
  "youtube",
];

export const SCHEDULE_EDIT_BLOCKED_STATES: readonly BriefState[] = [
  "researching",
  "drafting",
  "voice_review",
  "in_review",
  "approved",
  "scheduled",
  "published",
  "blocked",
  "cancelled",
];
